/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import Table from "../../../components/Table/Table";
import { SRNBaseColumns } from "../../../utils/utils";
import { Header } from "../../../components";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import AddSrnModal from "../../../components/AddSRNModal/AddSrnModal";

const rowsData = [
  {
    id: 0,
    ticketNumber: "TCKT-001245",
    folio: "DPID12345678",
    timeStamp: "2025-04-22 10:35:21",
    trackingId: "TRK987654",
    srn: "SRN123456",
  },
  {
    id: 1,
    ticketNumber: "TCKT-001246",
    folio: "DPID87654321",
    timeStamp: "2025-04-21 09:12:45",
    trackingId: "TRK654321",
    srn: "SRN654321",
  },
  {
    id: 2,
    ticketNumber: "TCKT-001247",
    folio: "DPID45678901",
    timeStamp: "2025-04-20 14:22:10",
    trackingId: "TRK123789",
    srn: "SRN789123",
  },
  {
    id: 3,
    ticketNumber: "TCKT-001248",
    folio: "DPID10987654",
    timeStamp: "2025-04-19 11:45:32",
    trackingId: "TRK321456",
    srn: "SRN456987",
  },
  {
    id: 4,
    ticketNumber: "TCKT-001249",
    folio: "DPID11223344",
    timeStamp: "2025-04-18 16:01:50",
    trackingId: "TRK789654",
    srn: "SRN321654",
  },
  {
    id: 5,
    ticketNumber: "TCKT-001250",
    folio: "DPID55667788",
    timeStamp: "2025-04-17 08:30:15",
    trackingId: "TRK654987",
    srn: "SRN987321",
  },
  {
    id: 6,
    ticketNumber: "TCKT-001251",
    folio: "DPID99887766",
    timeStamp: "2025-04-16 13:55:40",
    trackingId: "TRK321789",
    srn: "SRN654789",
  },
  {
    id: 7,
    ticketNumber: "TCKT-001252",
    folio: "DPID22334455",
    timeStamp: "2025-04-15 19:20:25",
    trackingId: "TRK987123",
    srn: "SRN321987",
  },
];

function SRN() {
  const [searchQuery, setSearchQuery] = useState("");
  const [modalOpen,setModalOpen]=useState(false)


  const handleModalOpen=()=>{
    setModalOpen(true)
  }

  const handleModalClose=()=>{
    setModalOpen(false)
  }
  const handleSearchQuery = useCallback((query) => {
    setSearchQuery(query.trim());
  }, []);

  const filteredRows = useMemo(() => {
    if (!searchQuery) return rowsData;
    return rowsData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [searchQuery]);

  const columns = useMemo(() => {
    const updatedColumns = [...SRNBaseColumns];

    updatedColumns[0] = {
      width: 180,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => <TicketButton ticketNumber={rowData.ticketNumber} ticketId={rowData.id} />,
    };

    return updatedColumns;
  }, []);

  return (
    <TableLayout
      header={
        <Header searchQuery={searchQuery} handleSearchQuery={handleSearchQuery}>
          <Button variant="contained" color="primary" onClick={handleModalOpen}>
            Add SRN
          </Button>
        </Header>
      }
    >
      <Table
        columns={columns}
        defaultColumns={columns}
        rows={filteredRows}
        hideCheckbox
        rowHeight={45}
        setHasActiveEdits={() => {}}
      />
      <AddSrnModal open={modalOpen} onClose={handleModalClose}/>
    </TableLayout>
  );
}

SRN.propTypes = {};

export default SRN;
